import { AdvisoryInfoIcon } from '../../components/icons/Icons.tsx';
import { SecondaryAdvisory } from '../SecondaryAdvisory.tsx';
import { AdvisoryLink } from './AdvisoryLink.tsx';

export const NoTFRAdvisory = () => {
    return (
        <SecondaryAdvisory header="Temporary Flight Restrictions" advisoryType='advise' icon={AdvisoryInfoIcon} iconColor="medium">
            Your mission is not restricted by any TFRs for this timeframe. For a list of all active and upcoming TFRs, visit <AdvisoryLink url="https://tfr.faa.gov" />.
        </SecondaryAdvisory>
    );
};
